import { Metadata } from '@redwoodjs/web';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';

export default function OrderSettingsPage() {
  return (
    <>
      <Metadata title="Order Settings" />
      <PageHeader pageType={PageType.OrderSettings}></PageHeader>
      <PageBody>todo</PageBody>
    </>
  );
}
